var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-option-key-hint",class:{ 'base-option-key-hint--selected': _vm.isSelected }},[_vm._v(" "+_vm._s(_vm.keyHint)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }